<template>
    <div v-if="!loading">
        <CRow class="justify-content-between align-items-center mt-3 mb-1">
            <CCol sm="6">
                <h5 v-if="state === 'view'" class="mt-2">{{ trainingProfileName }}</h5>
                <template v-else>
                    <CInput v-model="trainingProfileName" placeholder="TrainingProfile name" autocomplete="off" class="mt-2"/>
                </template>
            </CCol>
            <CCol sm="6">
                <template v-if="state === 'view'">
                    <span v-if="trainingProfileNonStandard" style="margin-left: 7px;">Special mode</span>
                    <CButtonGroup size="sm" v-if="!showDeleteConfirmation">
                        <CButton class="btn" color="info" variant="outline" @click="state='edit'" v-if="!this.trainingProfileIsGlobal">edit</CButton>
                        <CButton class="btn" color="info" variant="outline" @click="addOrUpdateOrCopyTrainingProfile(true)" v-if="!trainingProfileNonStandard">copy</CButton>
                        <CButton class="btn" color="info" variant="outline" @click="showDeleteConfirmation=true" v-if="!this.trainingProfileIsGlobal">delete
                        </CButton>
                        <CButton class="btn" color="info" @click="setNewTrainingProfile(null, trainingProfile)"  v-if="!trainingProfileNonStandard">new</CButton>
                    </CButtonGroup>
                    <CButtonGroup size="sm" v-else>
                        <CButton class="btn" color="info" variant="outline" @click="deleteTrainingProfile">Confirm deletion</CButton>
                        <CButton class="btn" color="info" @click="showDeleteConfirmation=false">Cancel</CButton>
                    </CButtonGroup>
                </template>
                <CButtonGroup v-else size="sm" class="mb-2">
                    <CButton class="btn" color="info" variant="outline" @click="setNewTrainingProfile(trainingProfile, null)">cancel</CButton>
                    <CButton class="btn" color="info" @click="addOrUpdateOrCopyTrainingProfile(false)">save</CButton>
                </CButtonGroup>
            </CCol>
        </CRow>
        <div v-for="category in ['catch', 'finish', 'other']" :key="category">
            <CRow v-if="checksVals[category][0] || state==='edit'" :class="!checksVals[category][0] && state==='edit' ? 'mb-2' : ''">
                <CCol><h6>{{ category !== 'Other' ? category.charAt(0).toUpperCase() + category.slice(1) : 'Sequence' }}</h6></CCol>
            </CRow>
            <!--suppress JSUnusedLocalSymbols -->
            <CheckConfiguration :state="state" v-model="checksVals[category][checkNum]" @changed="onChecksChanged"
                                :availableChecks="availableChecks[category]" :category="category" :freeChecksSlotsQty="freeChecksSlotsQty"
                                v-for="(checkVal, checkNum) in checksVals[category]" :key="checkNum"/>
        </div>
        <CRow v-if="!checksVals['catch'][0] && !checksVals['finish'][0] && !checksVals['other'][0] && state!=='edit'">
            <CCol><h6>No checks</h6></CCol>
        </CRow>
    </div>
    <div v-else>
        <CRow class="mt-2 mb-1">
            <CCol sm="12">
                <h5>{{ trainingProfile.name }}</h5>
            </CCol>
        </CRow>
        <CRow class="mt-5 mb-5 justify-content-sm-center">
            <CCol sm="auto">
                <Spinner/>
            </CCol>
        </CRow>
    </div>
</template>


<script>
    import Spinner from "@/components/Spinner"
    import CheckConfiguration from "@/components/CheckConfiguration"
    import gql from "graphql-tag"
    import {apolloClient} from "@/plugins/apollo"
    import {checksSchema} from "@/scripts/checks-schema"
    import {printSeparated} from "@/scripts/utils";

    function createChecksVals() {
        let checksVals = {}
        for (let category in checksSchema) {
            checksVals[category] = {}
            for (let i = 0; i < tableRowsQty; i++)
                checksVals[category][i] = null
            checksVals[category][tableRowsQty] = false
        }
        return checksVals
    }

    const tableRowsQty = 9

    export default {
        props: {
            trainingProfile: {}
        },
        components: {
            Spinner,
            CheckConfiguration
        },
        data() {


            return {
                state: ['edit', 'view'][1],
                checksVals: createChecksVals(),
                availableChecks: JSON.parse(JSON.stringify(checksSchema)),
                trainingProfileName: '',
                trainingProfileId: null,
                trainingProfileIsGlobal: false,
                trainingProfileNonStandard: false,
                showDeleteConfirmation: false,
                loading: false,
                freeChecksSlotsQty: tableRowsQty
            }
        },
        methods: {
            async setNewTrainingProfile(newTrainingProfile, oldTrainingProfile) {
                if (newTrainingProfile === null && oldTrainingProfile === null) {
                    this.$emit('outerNewTrainingProfileCanceled')
                } else if (newTrainingProfile !== oldTrainingProfile) {
                    if (newTrainingProfile) {
                        this.state = 'view'
                        this.trainingProfileName = newTrainingProfile.name
                        this.trainingProfileId = newTrainingProfile.id
                        this.loading = true
                        let query = gql`
                            {
                                trainingProfile (trainingProfileId: ${newTrainingProfile.id}) {
                                    id
                                    json
                                    isGlobal
                                    nonStandard
                                }
                            }
                        `
                        let qRes = await apolloClient.query({query})
                        // noinspection UnnecessaryLocalVariableJS
                        let res = qRes.data['trainingProfile']
                        let json = JSON.parse(res['json'])
                        this.trainingProfileIsGlobal = res.isGlobal
                        this.trainingProfileNonStandard = res.nonStandard
                        this.trainingProfileJsonToChecksVals(json)
                        this.loading = false
                        this.onChecksChanged()
                    } else {
                        this.state = 'edit'
                        this.trainingProfileName = 'My style'
                        this.trainingProfileId = null
                        this.trainingProfileIsGlobal = false
                        this.trainingProfileNonStandard = false
                        for (let category in checksSchema) {
                            for (let i = 0; i < tableRowsQty; i++)
                                this.checksVals[category][i] = null
                            this.checksVals[category][tableRowsQty] = false
                        }
                        this.onChecksChanged()
                    }
                }
            },
            async deleteTrainingProfile() {
                let mutation = gql`
                     mutation {
                                deleteTrainingProfile(trainingProfileId: ${this.trainingProfileId}) {
                                    success
                                }
                            }
                `
                await apolloClient.mutate({mutation})
                this.$emit('trainingProfileDeleted')
            },
            async addOrUpdateOrCopyTrainingProfile(copyFlag) {
                this.state = 'view'
                let trainingProfileJson = this.checksValsToTrainingProfileJson()
                if (!this.trainingProfileId || copyFlag) {
                    let mutation = gql`
                         mutation {
                                    addTrainingProfile(addTrainingProfile: {name: ${JSON.stringify(this.trainingProfileName)}, json: ${JSON.stringify(JSON.stringify(trainingProfileJson))}}) {
                                        trainingProfile {
                                            id
                                            name
                                        }
                                    }
                                }
                    `
                    let qRes = await apolloClient.mutate({mutation})
                    let res = qRes.data['addTrainingProfile']
                    this.$emit('trainingProfileChanged', res['trainingProfile'], !copyFlag)
                } else {
                    let mutation = gql`
                         mutation {
                                    updateTrainingProfile(updateTrainingProfile: {trainingProfileId: ${this.trainingProfileId}, name: ${JSON.stringify(this.trainingProfileName)}, json: ${JSON.stringify(JSON.stringify(trainingProfileJson))}}) {
                                        trainingProfile {
                                            id
                                            name
                                        }
                                    }
                                }
                    `
                    let qRes = await apolloClient.mutate({mutation})
                    let res = qRes.data['updateTrainingProfile']
                    this.$emit('trainingProfileChanged', res['trainingProfile'], true)
                }
            },
            onChecksChanged() {
                let usedChecks = []
                let trainingProfileSetChecksQty = 0
                for (let category in checksSchema) {
                    let setChecksQty = 0
                    let oldCheckVals = JSON.parse(JSON.stringify(this.checksVals))
                    for (let i = 0; i < tableRowsQty + 1; i++) {
                        let checkVal = oldCheckVals[category][i]
                        if (checkVal) {
                            this.checksVals[category][setChecksQty] = checkVal
                            usedChecks.push(checkVal.name)
                            setChecksQty++
                        }
                    }
                    trainingProfileSetChecksQty += setChecksQty
                    this.checksVals[category][setChecksQty] = false
                    setChecksQty++
                    for (let j = setChecksQty; j < tableRowsQty + 1; j++)
                        this.checksVals[category][j] = null
                }
                this.freeChecksSlotsQty = tableRowsQty - trainingProfileSetChecksQty
                for (let category in checksSchema) {
                    this.availableChecks[category] = checksSchema[category].filter(e => !usedChecks.includes(e))
                }
            },
            checksValsToTrainingProfileJson() {
                let json = {
                    'checks': {},
                    'checks_order': []
                }
                for (let category in checksSchema) {
                    {
                        for (let i = 0; i < tableRowsQty; i++) {
                            let checkVal = this.checksVals[category][i]
                            if (checkVal) {
                                json['checks'][checkVal['name']] = checkVal['kwargs']
                                json['checks_order'].push(checkVal['name'])
                            }
                        }
                    }
                }
                return json
            },
            trainingProfileJsonToChecksVals(json) {
                for (let category in checksSchema) {
                    let setChecksQty = 0
                    for (let checkName of json['checks_order']) {
                        // noinspection JSUnfilteredForInLoop
                        if (checksSchema[category].includes(checkName)) {
                            // noinspection JSUnfilteredForInLoop
                            this.checksVals[category][setChecksQty] = {name: checkName, kwargs: json['checks'][checkName]}
                            setChecksQty++
                        }
                    }
                    this.checksVals[category][setChecksQty] = false
                    setChecksQty++
                    for (let j = setChecksQty; j < tableRowsQty + 1; j++)
                        this.checksVals[category][j] = null
                }
            }
        },
        watch: {
            trainingProfile(newTrainingProfile, oldTrainingProfile) {
                this.setNewTrainingProfile(newTrainingProfile, oldTrainingProfile)
            },
            state(newVal) {
                if (newVal === 'edit') {
                    this.$emit('trainingProfileEditStart')
                }
                else {
                    this.$emit('trainingProfileEditStop')
                }

            }
        },
        created() {
            this.setNewTrainingProfile(this.trainingProfile)
        },


    }
</script>

<style scoped>
    .btn:focus {
        outline: none;
        box-shadow: none;
    }
</style>